import { TFunction } from "i18next";

import { Devices } from "../../../types/Device.types";

export const getLocalizedDeviceName = (
  deviceName: Devices | undefined,
  t: TFunction,
  lowercase: boolean
) => {
  let deviceNameString = "";
  switch (deviceName) {
    case Devices.Network:
      deviceNameString = lowercase
        ? t("NETWORK_LOWERCASE")
        : t("NETWORK_TITLECASE");
      break;
    case Devices.Camera:
      deviceNameString = lowercase
        ? t("CAMERA_LOWERCASE")
        : t("CAMERA_TITLECASE");
      break;
    case Devices.Speaker:
      deviceNameString = lowercase
        ? t("SPEAKER_LOWERCASE")
        : t("SPEAKER_TITLECASE");

      break;

    case Devices.Mic:
      deviceNameString = lowercase
        ? t("MICROPHONE_LOWERCASE")
        : t("MIC_TITLECASE");
      break;
    default:
      deviceNameString = "";
  }
  return deviceNameString;
};
